import {
  Title,
  Legend,
  Tooltip,
  LinearScale,
  LineElement,
  PointElement,
  CategoryScale,
  Chart as ChartJS
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";
import { format, parseISO, startOfWeek, endOfWeek } from "date-fns";

import { options } from "./config";

ChartJS.register(
  Title,
  Legend,
  Tooltip,
  LinearScale,
  LineElement,
  PointElement,
  CategoryScale
);

export default function LinePlot({ data, metricId, series, color, bucket = "day" }) {
  const plotData = {
    labels: data.map(entry => format(parseISO(entry.date), "dd/MM")),
    datasets: [
      {
        backgroundColor: color,
        borderRadius: 8,
        width: 2,
        label: metricId,
        data: data.map(entry => entry[series]),
        tension: 0.25,
        pointStyle: "dot",
        pointRadius: 0,
        borderColor: color
      }
    ]
  };
  return (
    <Line
      data={plotData}
      options={{
        ...options,
        plugins: {
          ...(options?.plugins || {}),
          tooltip: {
            ...(options?.plugins?.tooltip || {}),
            callbacks: {
              ...(options?.plugins?.tooltip?.callbacks || {}),
              title: items => {
                const idx = items?.[0]?.dataIndex ?? 0;
                const d = parseISO(data[idx].date);
                if (bucket === "week") {
                  const s = startOfWeek(d, { weekStartsOn: 1 });
                  const e = endOfWeek(s, { weekStartsOn: 1 });
                  return `${format(s, "dd/MM")}–${format(e, "dd/MM")}`;
                }
                return format(d, "dd/MM");
              }
            }
          }
        }
      }}
    />
  );
}
